// childIndex picks the set filter inside an agMultiColumnFilter.
// Only filters defined with the v34 handler API expose a handler. The multi-filters
// built by getColumnDefsHook are legacy filters, which keep the (deprecated)
// setFilterValues on their filter instances, so fall back to the instance.
export const getSetFilter = async (gridApi, columnId, childIndex) => {
  const filterHandler = gridApi.getColumnFilterHandler(columnId);
  const setFilterHandler =
    childIndex === undefined
      ? filterHandler
      : filterHandler?.getHandler?.(childIndex);

  if (typeof setFilterHandler?.setFilterValues === 'function') {
    return setFilterHandler;
  }

  const filterInstance = await gridApi.getColumnFilterInstance(columnId);
  const setFilterInstance =
    childIndex === undefined
      ? filterInstance
      : filterInstance?.getChildFilterInstance?.(childIndex);

  return typeof setFilterInstance?.setFilterValues === 'function'
    ? setFilterInstance
    : undefined;
};
